export const getProfile = state => state.profileReducer;
export const getProfileDetails = state => state.profileReducer.profile;
export const getProfileEmail = state => getProfileDetails(state)?.email;
export const getProfileAddresses = state =>
  getProfileDetails(state).profileAddresses;
